import axios from "axios"

export const show = async ({ params }) => {
    return axios.get(`${process.env.REACT_APP_REMAX_PS_API_URL}/exclude/dashboard`, {
        params: {}
    }).then(res => res.data)
}